import { render, staticRenderFns } from "./IncidenciasSoftware.vue?vue&type=template&id=33ed5d33&"
import script from "./IncidenciasSoftware.vue?vue&type=script&lang=js&"
export * from "./IncidenciasSoftware.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports